export default class PersonLiteDomainService {
    static getBirthDate(person) {
        if (person.birthDate) {
            return new Date(person.birthDate);
        }
        return null;
    }
    static fromJSON(json) {
        return Object.assign({}, json);
    }
}
